export default function PaginationMetaDetails({ pagination }) {
    return (
            <p>
                Showing {pagination.from} to {pagination.to} of{" "}
                {pagination.total} blogs
            </p>
    );
}
